import { render, staticRenderFns } from "./DailyLivingSkills.vue?vue&type=template&id=c241f91e"
import script from "./DailyLivingSkills.vue?vue&type=script&lang=js"
export * from "./DailyLivingSkills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports